import { render, staticRenderFns } from "./dinopop.vue?vue&type=template&id=fc7904e4&scoped=true"
import script from "./dinopop.vue?vue&type=script&lang=js"
export * from "./dinopop.vue?vue&type=script&lang=js"
import style0 from "./dinopop.vue?vue&type=style&index=0&id=fc7904e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7904e4",
  null
  
)

export default component.exports